import gql from 'graphql-tag'
import { gqlast } from '../graphqlParser'
import { Base64 } from 'js-base64'

/* Función para crear evento */
const CREATE_EVENT = (event) => {
    let paymentMethods = [
        { name: "Tarjeta de crédito o débito", icon: "fas fa-credit-card" },
        { name: "SPEI", icon: "fas fa-landmark" },
        { name: "Pago en OXXO", icon: "fas fa-money-bill" }
    ];
    const newEvent = {
        name: event.name,
        category: event.category,
        subcategory: event.subcategory,
        eventType: event.eventType,
        registrationWebSite: event.registrationWebSite,
        details: event.details,
        modality: event.modality,
        eventImage: event.eventImage,
        eventFlyer: event.eventFlyer,
        startDate: event.startDate,
        endDate: event.endDate,
        startTime: event.startTime,
        endTime: event.endTime,
        amenities: event.amenities,
        contactDetails: event.contactDetails,
        socialMedia: event.socialMedia,
        address: event.address,
        faqs: formatFaqs(event.faqs),
        contactDetails: event.contactDetails,
        paymentMethods: paymentMethods,
        tags: event.tags,
        installments: event.installments,
        onlineEventUrl: event.onlineEventUrl,
        meetingId: event.meetingId,
        meetingPass: event.meetingPass,
        totalBreakdown: event.totalBreakdown,
        private: event.private,
        tickets: formatTickets(event.tickets),
        haveCoupons: event.haveCoupons,
        hideCompany: event.hideCompany,
        hidePhone: event.hidePhone,
        offerBilling: event.offerBilling,
        productsPerOrder: event.productsPerOrder,
        coupons: formatCoupons(event.coupons),
        quantityOfCourtesies: event.quantityOfCourtesies,
        courtesy: event.courtesy,
        extraFields: event.extraFields ? event.extraFields : [],
        sponsors: event.sponsors,
        freeEvent: event.freeEvent,
        hasSurvey: event.hasSurvey,
        editorEmail: event.editorEmail,
        surveyEndDate: event.surveyEndDate,
        publishedURL: event.publishedURL,
        editorURL: event.editorURL,
        spreadsheetId: event.spreadsheetId,
        message: event.message
    }
    const newMutation = gqlast `mutation {
        createEvent(data:${newEvent}) {
           id
           name
        }
    }`
    return gql `${newMutation}`
}

/* Función para editar evento */
const UPDATE_EVENT = (event) => {
    const updatedEvent = {
        id: event.id,
        name: event.name,
        category: event.category,
        subcategory: event.subcategory,
        eventType: event.eventType,
        registrationWebSite: event.registrationWebSite,
        details: event.details,
        modality: event.modality,
        eventImage: event.eventImage,
        eventFlyer: event.eventFlyer,
        startDate: event.startDate,
        endDate: event.endDate,
        startTime: event.startTime,
        endTime: event.endTime,
        amenities: event.amenities,
        contactDetails: event.contactDetails,
        socialMedia: event.socialMedia,
        address: event.address,
        faqs: formatFaqs(event.faqs),
        contactDetails: event.contactDetails,
        tags: event.tags,
        installments: event.installments,
        onlineEventUrl: event.onlineEventUrl,
        meetingId: event.meetingId,
        meetingPass: event.meetingPass,
        totalBreakdown: event.totalBreakdown,
        private: event.private,
        tickets: formatTicketsForUpdate(event.tickets),
        haveCoupons: event.haveCoupons,
        hideCompany: event.hideCompany,
        hidePhone: event.hidePhone,
        offerBilling: event.offerBilling,
        productsPerOrder: event.productsPerOrder,
        coupons: formatCoupons(event.coupons),
        quantityOfCourtesies: event.quantityOfCourtesies,
        courtesy: event.courtesy,
        extraFields: event.extraFields ? event.extraFields : [],
        sponsors: event.sponsors,
        freeEvent: event.freeEvent,
        hasSurvey: event.hasSurvey,
        editorEmail: event.editorEmail,
        surveyEndDate: event.surveyEndDate,
        publishedURL: event.publishedURL,
        editorURL: event.editorURL,
        spreadsheetId: event.spreadsheetId,
        message: event.message
    }
    const omitTypename = (key, value) => (key === '__typename' ? undefined : value)
    const newPayload = JSON.parse(JSON.stringify(updatedEvent), omitTypename)

    const newMutation = gqlast `mutation {
        updateEvent(data:${newPayload}) {
           id
           name
        }
    }`
    return gql `${newMutation}`
}

/* Función para eliminar evento */
const DELETE_EVENT = (id) => {
    const newMutation = gqlast `mutation {
        deleteEvent(id:${id})
    }`
    return gql `${newMutation}`
}

/* Función para dar formato a los boletos de un nuevo evento y sea aceptado en el modelo de GraphQL*/
const formatTickets = (tickets) => {
    let formattedTickets = tickets.map((ticket) => {
        ticket.inventory.quantity = ticket.inventory.quantity ? parseInt(ticket.inventory.quantity) : 0
        ticket.price = parseFloat(ticket.price)
        ticket.productType = "TICKET"
        delete ticket.inventory.sold
        return ticket
    });
    return formattedTickets
}

/* Función para dar formato a los boletos de un evento existente y sea aceptado en el modelo de GraphQL*/
const formatTicketsForUpdate = (tickets) => {
    let formattedTickets = tickets.map((ticket) => {
        ticket.inventory.quantity = ticket.inventory.quantity ? parseInt(ticket.inventory.quantity) : 0
        ticket.price = parseFloat(ticket.price)
        ticket.productType = "TICKET"
        ticket.inventory.sold = ticket.inventory.sold ? parseInt(ticket.inventory.sold) : 0
        return ticket
    });
    return formattedTickets
}

/* Función para dar formato a los cupones de un evento y sea aceptado en el modelo de GraphQL*/
const formatCoupons = (coupons) => {
    let formattedCoupons = coupons.map((coupon) => {
        coupon.percentOff = parseFloat(coupon.percentOff)
        return coupon
    });
    return formattedCoupons
}

/* Función para dar formato a las preguntas frecuentes de un evento y sea aceptado en el modelo de GraphQL*/
const formatFaqs = (faqs) => {
    let formattedFaqs = faqs.map((faq) => {
        faq.answer = Base64.encode(faq.answer)
        return faq
    })
    for (let i = 0; i < formattedFaqs.length; i++) {
        if (
            formattedFaqs[i].question == ''
        ) {
            formattedFaqs.splice(i, 1);
        }
    }
    return formattedFaqs
}

const UPDATE_SURVEY = (payload) => {
    const updatedEvent = {
        ...payload
    }
    const omitTypename = (key, value) => (key === '__typename' ? undefined : value)
    const newPayload = JSON.parse(JSON.stringify(updatedEvent), omitTypename)

    const newMutation = gqlast `mutation {
        updateSurvey(data:${newPayload})
    }`
    return gql `${newMutation}`
}
export { CREATE_EVENT, DELETE_EVENT, UPDATE_EVENT, UPDATE_SURVEY }